function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* @indexer:no-export */
import React from 'react';
import './TableRow.css';
import cs from 'classnames';
import ThemeContext from '../../ThemeContext';
var TableRow = /*#__PURE__*/function (_React$Component) {
  _inherits(TableRow, _React$Component);
  function TableRow() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, TableRow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TableRow)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.handleAnimationEnd = function () {
      _this.props.onHighlight(_this.props.dmId);
      _this.removeAnimationHandler();
    };
    _this.removeAnimationHandler = function () {
      var el = _this.props.forwardedRef && _this.props.forwardedRef.current;
      el && el.removeEventListener('animationend', _this.handleAnimationEnd);
    };
    return _this;
  }
  _createClass(TableRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.shouldHighlight) {
        var el = this.props.forwardedRef && this.props.forwardedRef.current;
        el && el.addEventListener('animationend', this.handleAnimationEnd, false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeAnimationHandler();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        dmId = _this$props.dmId,
        shouldHighlight = _this$props.shouldHighlight,
        forwardedRef = _this$props.forwardedRef;
      return /*#__PURE__*/React.createElement("div", {
        ref: forwardedRef,
        role: "row",
        className: cs(className, {
          'client-color1-fg-white-75': shouldHighlight,
          'dm-highlight-row': shouldHighlight
        }, this.context),
        tabIndex: -1,
        "data-dm-id": dmId
      }, children);
    }
  }]);
  return TableRow;
}(React.Component);
TableRow.contextType = ThemeContext;
export default React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TableRow, Object.assign({}, props, {
    forwardedRef: ref
  }));
});